






















































































































































































































































































































































// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ApsStatic from './components/static/ApsStatic.vue';
import ScarceSkillsStatic from './components/static/ScarceSkillsStatic.vue';
import TvetStatic from './components/static/TVETStatic.vue';
import UniversityApplicationsStatic from './components/static/UniversityApplicationsStatic.vue';

@Component({
  components: {
    ApsStatic,
    ScarceSkillsStatic,
    TvetStatic,
    UniversityApplicationsStatic,
  },
})
export default class LearnersStaticPage extends Vue {
  showSideNav: string = '';
}
